import { Grid, GridItem, Stack, Text } from "@chakra-ui/react";
import { Instant } from "@js-joda/core";
import React from "react";
import DocumentPaper, { DocumentReviewHeader } from "./DocumentPaper";
import type { LayoutBlock, LayoutRow } from "./layout/documentLayout";

// GENERAL documents: the paper with the PDF's 4-column rows (see layoutRows). Each row is its own
// grid so a row's blocks line up with each other only, like the PDF's `.block-row` flex rows.

const COLUMNS = 4;

interface Props {
  header: DocumentReviewHeader;
  rows: LayoutRow[];
  submittedAt: Instant | null;
  title: string;
  renderBlock: (block: LayoutBlock) => React.ReactNode;
}

export default function DocumentPreview(props: Props) {
  return (
    <DocumentPaper header={props.header} submittedAt={props.submittedAt} title={props.title}>
      {props.rows.length === 0 ? (
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          This document has no questions to show.
        </Text>
      ) : (
        <Stack spacing="22px">
          {props.rows.map((row) => (
            <Grid
              key={row.blocks[0].question.id}
              columnGap="32px"
              templateColumns={`repeat(${COLUMNS}, minmax(0, 1fr))`}
            >
              {row.blocks.map((block) => (
                <GridItem key={block.question.id} colSpan={block.width ?? COLUMNS} minW={0}>
                  {props.renderBlock(block)}
                </GridItem>
              ))}
            </Grid>
          ))}
        </Stack>
      )}
    </DocumentPaper>
  );
}
